import { SHARED_REACT_QUERY_CONFIG } from "../../constants/reactQuery.constant";
import { myProducts } from "../../services/products/products.service";

export const PRODUCTS_QUERY = "products";
export const PRODUCTS_QUERY_CONFIG = SHARED_REACT_QUERY_CONFIG;

export const productsQuery = async () => {
  const request = await myProducts();
  return request.data;
};
